import { createReducer } from "@reduxjs/toolkit";
import {
  AddPostAuditEvent,
  getListActionSuccess,
  loadingProcedureJob,
  RemovePostAuditEvents,
  updatePostAuditEvent,
} from "./procedureJobAction";

export interface IProcedureState {
  //auditApprovalConfig?: any;
  procedureJobList?: any[];
  dataCount?: number;
  isLoading?: boolean;
  postAuditEvents: any[];
}

const initialState: IProcedureState = {
  procedureJobList: [],
  postAuditEvents: [],
};

export const procedureJobReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(loadingProcedureJob, (state, action) => {
      state = {
        ...state,
        isLoading: action.payload,
      };
      return state;
    })
    .addCase(getListActionSuccess, (state, action) => {
      state = {
        ...state,
        procedureJobList: action.payload?.data,
        dataCount: action.payload?.dataCount,
      };
      return state;
    })
    .addCase(updatePostAuditEvent, (state, action) => {
      let data = (action.payload ?? []).map((item, index) => {
        let cpy = { ...item };
        cpy["key"] = index + 1;
        return cpy;
      });
      state = {
        ...state,
        postAuditEvents: data,
      };
      return state;
    })
    .addCase(AddPostAuditEvent, (state, action) => {
      let update = {
        ...action.payload,
        key: (state.postAuditEvents ?? [])?.length + 1,
      };
      console.log(update);
      state = {
        ...state,
        postAuditEvents: (state?.postAuditEvents ?? []).concat(update),
      };
      return state;
    })
    .addCase(RemovePostAuditEvents, (state, action) => {
      let filter = state.postAuditEvents.filter(
        (item) => item.key !== action.payload.key,
      );
      state = {
        ...state,
        postAuditEvents: filter,
      };
      return state;
    });
});
